<template><section>
<h1>Switch 开关</h1>
<h2>基本用法</h2>
<p>通过v-model来绑定开关的闭合和关闭，类型为Boolean</p>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-switch v-model="switchActive"></nt-switch>
    <p>
        <span class="firstSpan"> {{switchActive?'开':'关'}}</span>
    </p>
  </div>
</template>




</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-switch</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"switchActive"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"firstSpan"</span>&gt;</span> {{switchActive?'开':'关'}}<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">switchActive</span>: <span class="hljs-literal">true</span>
    };
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>自定义颜色</h2>
<p>通过<strong>activeBgc</strong>传递状态为开时候的颜色,通过<strong>inactiveBgc</strong>传递状态为关时候的颜色</p>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-switch v-model="selfswitchActive" activeBgc="red" inactiveBgc="black"></nt-switch>
    <p>
        <span> {{selfswitchActive?'开':'关'}}</span>
    </p>
  </div>
</template>




</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-switch</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"selfswitchActive"</span> <span class="hljs-attr">activeBgc</span>=<span class="hljs-string">"red"</span> <span class="hljs-attr">inactiveBgc</span>=<span class="hljs-string">"black"</span> &gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-switch</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">span</span>&gt;</span> {{selfswitchActive?'开':'关'}}<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">selfswitchActive</span>:<span class="hljs-literal">false</span>
    };
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h2>监听事件</h2>
<p>通过绑定change事件，当开关点击时就会触发，参数为切换后的新值</p>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-switch v-model="switchActive" @change="handleSwitchChange"></nt-switch>
  </div>
</template>




</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-switch</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"switchActive"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleSwitchChange"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-switch</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">switchActive</span>: <span class="hljs-literal">true</span>
    };
  },
  <span class="hljs-attr">methods</span>: {
    handleSwitchChange(val) {
      alert(<span class="hljs-string">`切换后的新值为<span class="hljs-subst">${val}</span>`</span>);
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>


</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<p>通过v-model来绑定开关的闭合和关闭，类型为Boolean</p>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">v-model</td>
<td style="text-align:left">绑定开关的闭合和关闭</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">—</td>
<td style="text-align:left">false</td>
</tr>
<tr>
<td style="text-align:left">activeBgc</td>
<td style="text-align:left">状态为开时候的颜色</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">#3399CC(主题色)</td>
</tr>
<tr>
<td style="text-align:left">inactiveBgc</td>
<td style="text-align:left">状态为关时候的颜色</td>
<td style="text-align:left">String</td>
<td style="text-align:left">-</td>
<td style="text-align:left">#ccc</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">点击开关时触发的事件</td>
<td style="text-align:left">参数为切换后的新值</td>
</tr>
</tbody>
</table>
</section></template>

<script>
    export default {
      data() {
        return {
          switchActive: true,
          selfswitchActive:false
        };
      },
      methods: {
        handleSwitchChange(val) {
          alert(`切换后的新值为${val}`);
        }
      }
    }
</script>